<template>
    <div class="wui-lifestyle-item" v-if="info.id">
        <router-link :to="`/community/${info.id}`" class="lifestyle">
            <div class="cover"
                :class="{'cover-rectangle': info.rectangle}">
                <img class="img" onerror="this.style.display='none'" :src="util.thumb(info.coverUrl || info.cover, 500)" loading="lazy" decoding="async">
<!--                <img class="video" v-if="info.video.video" src="@/assets/img/icon-video.png">-->

            </div>
            <div class="base">
                <div class="title">{{info.title}}</div>
                <div class="info">
                    <div class="user">
                        <img class="avatar" :src="util.thumb(info.user?.avatar, 100)" loading="lazy" decoding="async">
                        <span class="name">{{info.user?.name}}</span>
                    </div>
                    <div class="comment">
                      <CollectNumber :width="14" :height="14" :fontSize="10" color="#666666" :objId="info.id" :type=2 :number="info.collectCount" :isCollect="info.isCollect">
                      </CollectNumber>
                    </div>
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
import CollectNumber from "@/components/CollectNumber.vue";
export default {
    components: {
        CollectNumber
    },
    props: {
        info: {
            type: Object,
        },
    },
};
</script>

<style scoped>
.wui-lifestyle-item {
    background: #FFFFFF;
    border-radius: 6px;
    margin-bottom: 12px;
}

.lifestyle .cover {
    position: relative;
    padding-bottom: 100%;
}

.lifestyle .cover-rectangle {
    padding-bottom: 150%;
}

.lifestyle .cover .img {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 6px 6px 0 0;
    object-fit: cover;
}

.lifestyle .cover .video {
    position: absolute;
    right: 10px;
    bottom: 10px;
    width: 16px;
    height: 16px;
}
.lifestyle .cover .video-preview {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    border-radius: 6px 6px 0 0;
}

.lifestyle .base {
    padding: 10px;
}

.lifestyle .base .title {
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #111111;
    margin-bottom: 6px;
}

.lifestyle .base .info {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.lifestyle .base .user {
    display: flex;
    align-items: center;
    height: 19px;
}

.lifestyle .base .user .avatar {
    height: 19px;
    width: 19px;
    border-radius: 3px;
    margin-right: 6px;
}

.lifestyle .base .user .name {
    font-size: 10px;
    color: #111111;
    white-space: nowrap;
    width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.lifestyle .base .comment {
    display: flex;
    align-items: center;
    height: 19px;
}

.lifestyle .base .comment .iconfont {
    font-size: 10px;
    color: #666666;
    margin-right: 5px;
}

.lifestyle .base .comment .total {
    font-size: 10px;
    color: #666666;
}

</style>
